import { render, staticRenderFns } from "./ywWithdrawRecord.vue?vue&type=template&id=6a2abf96&scoped=true"
import script from "./ywWithdrawRecord.vue?vue&type=script&lang=js"
export * from "./ywWithdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./ywWithdrawRecord.vue?vue&type=style&index=0&id=6a2abf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2abf96",
  null
  
)

export default component.exports